import React from 'react';
import {getFieldOperator} from '../../../_shared/GWTBridge/invoke/procMain';
import {getServerTexts} from '../texts/programRep/texts';
import {ProcSearch} from './ProcSearch';
import {Root} from 'react-dom/client';

export async function renderProcSearch(root: Root, props) {
    const dropdownRef: React.RefObject<typeof ProcSearch> = React.createRef();
    await getServerTexts();

    const operator = getFieldOperator(props.fieldNum);

    root.render(<ProcSearch ref={dropdownRef} {...props} operator={operator} />);

    return dropdownRef;
}
